import { commonLang } from '@umu/ukit-lang';
/*
 * @author: wayou
 * @date: 2018-08-28 17:24:50
 * @description: 顶部导航
 */

import React, { useEffect, useState } from 'react';
import umuWebview from '@umu/umu-webview';
import { isInIframe } from '@umu/umu-dom';
import { IUserInfo } from '@umu/umu-types';
import { components } from 'common';
const { If, ToggleLine, Button } = components;

import TopBarLogo from './topBarLogo/topBarLogo';
import UserMenu from '../@userMenu/userMenu';
import {
    isInMiniProgram as checkIfInMiniProgram,
    isFromCourseMiniApp,
    isFromLive,
    isInPinIFrame,
} from '../../@utils/umuUtil';
import MiniProgramBar from './@miniProgramBar/miniProgramBar';
import {
    WrapperUseMobileIframeLandscapeDisplayManager,
    IWrapperUseMobileIframeLandscapeDisplayProps,
} from '../../services/responsiveDisplay/course';
import './topBar.scss';

interface ITopBarProps extends IWrapperUseMobileIframeLandscapeDisplayProps {
    title?: string;
    userInfo?: IUserInfo;
    backUrl?: string;
    onTitleClick?: () => void;
    children?: JSX.Element;
    isShowUserMenu?: boolean; // 兼容搜索
    isForceShow?: boolean;
    isShowInIframe?: boolean; // 在Iframe 下仍然显示
    customizedLogo?: string;
    customizedBackIcon?: JSX.Element;
}

function TopBar(props: ITopBarProps) {
    const { title = '', backUrl, children, customizedLogo, customizedBackIcon } = props;
    const [isInLiveMiniApp, setIsInLiveMiniApp] = useState(false);

    useEffect(() => {
        checkIfInMiniProgram((is) => {
            setIsInLiveMiniApp(is && isFromLive());
        });
    }, []);

    const onTitleClick = () => {
        if (props.onTitleClick) {
            props.onTitleClick();
        }
    };

    const renderContent = () => {
        return (
            <div className="nav-item nav-content">
                <If condition={!!title}>
                    <div
                        onClick={onTitleClick}
                        style={{
                            cursor: `${!!props.onTitleClick ? 'pointer' : 'default'}`,
                        }}
                    >
                        <ToggleLine
                            text=""
                            theme="1"
                            maxLine={1}
                            className=""
                            labelOpen=""
                            labelClosed=""
                            expandByBtn={true}
                        >
                            {title}
                        </ToggleLine>
                    </div>
                </If>
                {!title && children ? children : null}
            </div>
        );
    };

    const renderUserMenu = () => {
        const { isShowUserMenu } = props;
        if (typeof isShowUserMenu !== 'undefined' && isShowUserMenu === false) {
            return null;
        }
        return (
            <div className="nav-item nav-action">
                <UserMenu />
            </div>
        );
    };

    const render = () => {
        if (isInIframe() && !isInPinIFrame() && !props.isShowInIframe) {
            return null;
        }
        // web课程页，隐藏头
        if (isInIframe() && props._isDisplayInIframeModeForCourse && !props.isShowInIframe) {
            return null;
        }
        if (umuWebview && umuWebview.UA_INFO.isUMUWebview && !props.isForceShow) {
            return null;
        }
        if (isInLiveMiniApp) {
            return <MiniProgramBar></MiniProgramBar>;
        }
        if (isFromCourseMiniApp()) {
            return null;
        }
        return (
            <div className="top-bar">
                <div className="top-bar-nav">
                    {customizedBackIcon}
                    <If condition={!customizedBackIcon}>
                        <>
                            <If condition={!!backUrl}>
                                <div className="nav-item nav-back">
                                    <Button
                                        className=""
                                        href={backUrl}
                                        alias="text"
                                        iconBefore={<i className="icon icon-arrow arrow1 blue left size-s"></i>}
                                    >
                                        {commonLang('返回')}
                                    </Button>
                                </div>
                            </If>
                            <If condition={!backUrl}>
                                <div className="nav-item nav-logo">
                                    <TopBarLogo customizedLogo={customizedLogo} />
                                </div>
                            </If>
                        </>
                    </If>
                    {renderContent()}
                    {renderUserMenu()}
                </div>
                <div className="top-bar-expand">{/* expand content goes here */}</div>
            </div>
        );
    };

    return render();
}

export default WrapperUseMobileIframeLandscapeDisplayManager(TopBar);
